import { allow_num } from "@/utils/validations.js";

export default {
  name: 'SpouseDetail',
  props: {
    spouse_data: {
      type: Object,
      default: () => ({
        spouseFirstNames: '',
        spouseMiddleName: '',
        spouseSurname: '',
        spouseIdType: 'Not Selected',
        spouseIdNo: '',
        spouseDateOfBirth: '',
        spousePhoneNumber: ''
      })
    }
  },
  methods: {
    allow_num,
    extract_date_from_id(id_number) {
      if (!id_number || id_number.length < 6) return '';
      
      // Extract first 6 digits (YYMMDD)
      const date_str = id_number.substring(0, 6);
      const year = parseInt(date_str.substring(0, 2));
      const month = date_str.substring(2, 4);
      const day = date_str.substring(4, 6);
      
      // Determine century (assuming people born after 2000 have year < 50)
      const full_year = year < 50 ? 2000 + year : 1900 + year;
      
      return `${full_year}${month}${day}`;
    }
  },
  watch: {
    spouse_data: {
      handler(new_value, old_value) {
        // Check if ID number changed and is ID type
        if (
            new_value.spouseIdType === 'ID Number' && 
            new_value.spouseIdNo !== old_value?.spouseIdNo &&
            new_value.spouseIdNo
          ) {
            const extract_date = this.extract_date_from_id(new_value.spouseIdNo);
            if (extract_date && extract_date !== new_value.spouseDateOfBirth) {
              new_value.spouseDateOfBirth = extract_date;
            }
        }
        this.$emit('update:spouse_data', new_value);
      },
      deep: true
    }
  },
};